import React from 'react';
import { observer, inject } from 'mobx-react';
import styles from './sizeValue.scss';
import { ISize, IVariantStore } from '../../../../../types';
import TabNavigationHelper from '../../../../../helpers/tabNavigationHelper';
import { AvailabilityStatusEnum } from '../../../../../stores/types';

export const SizeValue = inject('variantStore')(
    observer(({ variantStore, size, variantKey }: IVariantStore & ISizeValueProps) => {
        if (!variantStore)
            return null;
        const tabNavigation = TabNavigationHelper.instance;
        const enabledKiosk = variantStore.mainStore.showKioskLayout;

        function handleSelectedSizeChangeClick() {
            // We need this in order to have kiosk selected size update in variant panel
            // not for now
            // if (enabledKiosk)
            //     variantStore?.mainStore.workWearStoreStore.changeSelectedSize(size);
            variantStore?.changeSelectedSize(size);
        }

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        function variantAvailabilityState(sizeCode: number): string {
            if (!variantStore)
                return styles.variant_status_red;
            
            // not for now
            // const wwsStore = variantStore.mainStore.workWearStoreStore;
            // const status = wwsStore.
            //     variantAvailabilityState(sizeCode, VariantType.Size, variantKey, wwsStore.variantInfoInKiosk);

            const status = AvailabilityStatusEnum.InStock;
            let result = '';
            if (!variantKey)
                result = styles.inactive + ' ';

            if (status === AvailabilityStatusEnum.InStock)
                result += styles.variant_status_green;
            else
                result += styles.variant_status_red;

            return result;
        }

        function sizeValueClassNames(): string {
            const classNames:string[] = [styles.size_value, 'notranslate'];
            if (enabledKiosk) {
                classNames.push(styles.kiosk);
                const stateClass = variantAvailabilityState(size.code);
                classNames.push(stateClass);

                // not for now
                // if (variantStore?.mainStore.workWearStoreStore.selectedSize?.size.code == size.code)
                //     classNames.push(styles.active);
            }
            else {
                if (variantStore?.selectedSize?.size.code == size.code)
                    classNames.push(styles.active);
                if (!variantKey)
                    classNames.push(styles.sold_out_size);
            }
            return classNames.join(' ');
        }

        return (
            <div data-testid='flexset-size_values_icon-layer_2'
                data-semantic-id='flexset-size_values_icon-layer_2'
                data-flexset-id={variantStore?.selectedBrickItem.fsCode}
                data-flexset-name={variantStore?.mainStore.dataStore.orderModule.flexSetInfo.displayName}
                data-flexset-module-layer_0-category={variantStore?.getOMBrickSelection?.mainNavigationKeyPath}
                data-flexset-module-layer_0-index={variantStore?.getOMBrickPosition}
                data-flexset-module-layer_1-category={variantStore?.selectedBrickItem.mainNavigationKeyPath}
                data-flexset-module-layer_1-index={variantStore?.brickItemPosition}
                data-flexset-item-name={variantStore?.selectedBrickItem.salesDesignation}
                data-flexset-item-sku={variantStore?.mainStore.getSalesArticleNo(variantKey)}
                data-savkey={variantKey}
                className={sizeValueClassNames()}
                onClick={handleSelectedSizeChangeClick}
                ref={(el)=>tabNavigation.setFocusAtt(el)}>
                {size.name}
            </div>
        );
    })
);

export interface ISizeValueProps {
    size: ISize;
    variantKey: string;
}

